import { EmitOutput } from "./emit-output";

export type CompileCallback = (emitOutput: EmitOutput) => void;
